// src/Auth.js
import React, { useState } from 'react';
import { auth } from './firebaseConfig';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import logo from './logo.png'; // Importa a logo

function Auth() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetMessage, setResetMessage] = useState('');

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError('');
    setResetMessage('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error("Erro ao fazer login:", err.message);
      setError("Falha no login: Verifique e-mail e senha.");
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setError("Por favor, digite seu e-mail para resetar a senha.");
      return;
    }
    setError('');
    setResetMessage('');
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMessage("Um link de redefinição de senha foi enviado para o seu e-mail.");
    } catch (err) {
      console.error("Erro ao resetar senha:", err.message);
      setError("Erro ao enviar e-mail de redefinição. Verifique o e-mail digitado.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-xl text-center w-80">
        <img src={logo} alt="Logo da Empresa" className="mx-auto mb-6 max-h-20" /> {/* Sua Logo */}
        <h1 className="text-2xl font-bold mb-4">Acesso ao Controle</h1>
        <p className="text-gray-600 mb-6">Entre com seu e-mail e senha.</p>
        <form onSubmit={handleSignIn} className="space-y-4">
          <input 
            type="email" 
            placeholder="E-mail" 
            className="w-full p-2 border rounded" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
          <input 
            type="password" 
            placeholder="Senha" 
            className="w-full p-2 border rounded" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
          {error && <p className="text-red-500 text-sm">{error}</p>}
          {resetMessage && <p className="text-green-500 text-sm">{resetMessage}</p>}
          <button 
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full w-full"
          >
            Entrar
          </button>
          <button 
            type="button"
            onClick={handlePasswordReset}
            className="text-blue-600 hover:underline text-sm mt-2"
          >
            Esqueci minha senha
          </button>
        </form>
      </div>
    </div>
  );
}

export default Auth;